/*
 se llama un svg puro y dinámico para mostrar iconos personalizados
 se pueden transformar desde aquí https://react-svgr.com/playground/?icon=true
 tutorial aquí https://www.youtube.com/watch?v=wVtV8l7FIi0
*/

const MorningIcon = props => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 20 20'
			style={{
				enableBackground: 'new 0 0 20 20'
			}}
			xmlSpace='preserve'
			width='1em'
			height='1em'
			{...props}
		>
			<path d='M20 12.6c-.1-.3-.4-.4-.7-.4h-4.5v-.1c0-.2-.1-.5-.1-.7-.5-1.9-2.1-3.2-4-3.5-2.7-.3-5.2 1.6-5.5 4.3v.1H.4c-.2 0-.4.3-.4.5 0 .3.2.5.4.5h19c.2 0 .5-.1.6-.4v-.3zm-6.3-.4H6.3c.2-1.7 1.6-3 3.3-3.2 1-.1 2 .2 2.7.8.8.7 1.3 1.5 1.4 2.4zM17.6 14.2H2.7c-.6 0-.7.3-.7.5s.1.5.7.5h14.9c.2 0 .4-.2.4-.5 0-.2-.1-.5-.4-.5zM10 7.3c.3 0 .5-.2.5-.6V5.3c0-.1 0-.3-.2-.4-.1-.1-.2-.2-.4-.2l-.3.3c-.1.1-.1.2-.1.3v1.5c0 .3.2.5.5.5z' />
			<path d='M3.7 8c.1.1.2.3.3.4.2.2.5.4.7.6l.3.2c.1.1.2.1.4.1s.3-.1.4-.2V9c.1.1.2-.1.1-.2 0-.1-.1-.3-.2-.3-.3-.3-.6-.6-.9-.8l-.1-.1c-.1 0-.1-.1-.2-.1h-.2c-.1 0-.3 0-.4.1-.1.1-.2.2-.2.4h.2-.2zM14.6 9.4c.1 0 .3-.1.4-.1.4-.3.7-.6 1-.9.1-.1.2-.2.2-.4l-.1-.1.1-.1c-.1-.1-.2-.2-.3-.4-.2-.1-.5-.1-.6.1l-.3.2c-.3.2-.5.5-.8.7l-.1.1c-.1.1-.2.2-.2.4 0 .1.1.3.2.4.2.1.4.1.5.1z' />
		</svg>
	)
}

export default MorningIcon
